<template>
  <transition name="snack">
    <div
      v-if="show"
      class="absolute min-w-68 bottom-0 m-5 pl-4 pr-2 py-3 bg-gray-800 z-snackbar"
    >
      <div class="flex items-center">
        <span class="max-w-md mr-4 text-s leading-tight text-white">{{
          message
        }}</span>
        <div class="ml-auto flex items-center">
          <button
            v-if="action"
            class="ActionBtn px-2 py-5px mr-2 text-s"
            @click="doCallback"
          >
            <span class="text-highlight uppercase">{{ action }}</span>
          </button>
          <lm-icon-button
            class="mr-1"
            svg
            bg-black
            icon="close"
            @click="close"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import LmIconButton from '@/components/ui/LmIconButton'
import EventHub from '@/lib/eventHub'
import {Events} from '@/lib/definitions'

export default {
  name: 'Snackbar',
  components: {LmIconButton},
  data() {
    return {
      show: false,
      message: '',
      action: null,
      callback: null,
      params: null,
      autoClose: true,
      timeout: null
    }
  },
  mounted() {
    EventHub.on(
      Events.SHOW_SNACKBAR,
      (msg, action = null, callback = null, params = null, duration = 6000) => {
        this.reset()
        this.show = true
        this.message = msg
        this.callback = callback
        this.params = params
        if (action) this.action = action
        if (this.autoClose) {
          this.timeout = setTimeout(() => this.close(), duration)
        }
      }
    )
  },
  methods: {
    close() {
      this.show = false
    },
    doCallback() {
      if (this.action && this.callback) {
        this.callback(this.params)
      }
      this.show = false
    },
    reset() {
      this.show = false
      this.message = null
      this.action = null
      this.callback = null
      this.params = null
      if (this.timeout) clearTimeout(this.timeout)
    }
  }
}
</script>

<style scoped>
.ActionBtn:hover span {
  color: white;
}
.snack-enter-active,
.snack-leave-active {
  transition: opacity 0.5s ease,
    transform 0.5s cubic-bezier(0.04, 0.13, 0.55, 0.9);
}
.snack-enter,
.snack-leave-to {
  opacity: 0;
  transform: translateY(120%);
}
</style>
